<template>
  <div>
    <nav-title />
    <div class="layout-main">
      <div class="filter">
        <el-input
          type="number"
          size="small"
          v-model="groupId"
          placeholder="模板组ID"
        />
        <el-select v-model="sys" placeholder="系统" size="small">
          <el-option :label="item.name" :value="item.value" v-for="item in systemOptions" :key="item.value"></el-option>
        </el-select>
        <el-date-picker
          v-model="startDate"
          size="small"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="开始日期"
        >
        </el-date-picker>
        <el-date-picker
          v-model="endDate"
          size="small"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="结束日期"
        >
        </el-date-picker>

        <el-button
          type="primary"
          size="small"
          @click="queryList"
          style="margin-right:0;"
          >搜索</el-button
        >
        <el-button size="small" @click="resetCondition">重置</el-button>
      </div>
      <div class="list">
        <el-table
          ref="table"
          :data="list"
          stripe
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="id" label="模板ID" width="80">
          </el-table-column>
          <el-table-column
            prop="name"
            label="模板名称"
            width="200"
            align="center"
          >
          </el-table-column>
          <!--<el-table-column-->
          <!--prop="id"-->
          <!--label="尺寸">-->
          <!--<template slot-scope="scope">-->
          <!--<div>{{ scope.row.width||'?'}} x {{scope.row.height||'?'}}</div>-->
          <!--</template>-->
          <!--</el-table-column>-->
          <el-table-column prop="sys" label="适用系统" align="center">
          </el-table-column>
          <el-table-column prop="imp" label="展示量" align="right">
          </el-table-column>
          <el-table-column prop="clk" label="点击量" align="right">
          </el-table-column>
          <el-table-column prop="ratio" label="点击率" align="right">
          </el-table-column>
          <el-table-column prop="v_clk" label="有效点击" align="right">
          </el-table-column>
          <el-table-column prop="v_ratio" label="有效点击率" align="right">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          class="cl-pagination"
          background
          layout="prev, pager, next , sizes"
          @size-change="handleSizeChange"
          @current-change="handleChangePage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          :total="total"
          :current-page.sync="$store.state[namespace].page"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import NavTitle from 'components/NavTitle';
import ListMixins from 'mixins/list';
import { SYSTEM_OPTIONS } from 'constant/analysis';
export default {
  name: 'TemplateList',
  mixins: [ListMixins],
  components: {
    'nav-title': NavTitle
  },
  data() {
    return {
      namespace: 'analysis',
      groupId: '',
      sys: '',
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      systemOptions: SYSTEM_OPTIONS
    };
  },
  beforeDestroy() {
    this.$store.commit('analysis/update', {
      condition: {},
      list: [],
      total: 0,
      page: 1,
      pageSize: 10
    });
  },
  methods: {
    queryList() {
      this.$store.commit('analysis/update', {
        condition: {
          start_date: this.startDate || undefined,
          end_date: this.endDate || undefined,
          template_id: this.groupId || undefined,
          sys: this.sys || undefined,
          order_by: 'clk desc'
        }
      });
      this.refreshData();
    },
    resetCondition() {
      this.$store.commit('analysis/update', {
        condition: {}
      });
      this.groupId = '';
      this.sys = '';
      this.refreshData();
    },
    refreshData() {
      this.handleChangePage(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.cl-pagination {
  padding-bottom: 0;
}
.layout-main {
  min-height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.list {
  flex: 1;
}
.analysis-list {
  background: white;
  box-sizing: border-box;
  min-height: calc(100% - 52px);
}

.action {
  color: #3fb7ff;
  cursor: pointer;
  padding: 0 10px;
}

.filter {
  background: #fff;
  display: flex;
  padding-bottom: 20px;
  align-items: center;
  > * {
    margin-right: 8px;
    max-width: 150px;
  }
}
</style>
